<template>
  <div class="container py-5">

    <div class="buttons">
      <router-link 
        class="button is-primary"
        :to="{ name: 'AssemblyCreate' }">
        Create a New Assembly Sheet
      </router-link>

      <v-fade-transition mode="out-in">
        <button class="button"
          v-if="selected.length > 0"
          @click="launchConfirmDelete()">
          <span class="icon is-medium">
            <i class="fas fa-trash has-text-danger"></i>
          </span>
          <span>Delete {{ selected.length }} Selected Assembly Sheets</span>
        </button>
      </v-fade-transition>
    </div>

    <article 
      v-if="!loading && assemblySheets.length == 0" 
      class="message is-info is-fullwidth mt-3">
      <div class="message-body">
        There are no assembly sheets.
      </div>
    </article>

    <table class="table is-hoverable is-clickable is-fullwidth">
      <thead>
        <tr>
          <th @click.stop="">
            <v-checkbox :value="allSelected" @input="toggleAllSelected"/>
          </th>
          <th 
            v-for="(header, headerIndex) in headers" 
            :key="headerIndex">
            {{ header.label }}
          </th>
          <th></th>
        </tr>
        <tr v-if="loading">
          <th :colspan="headers.length + 2" class="py-0 px-0 is-naked">
            <v-progress class="is-fullwidth" v-model="loading"/>
          </th>
        </tr>
      </thead>

      <v-fade-transition mode="out-in">
        <tbody 
          :key="pagination.page" 
          v-if="!loading && assemblySheets.length > 0">
          <tr 
            class="v-centered"
            v-for="assemblySheet in assemblySheets"
            :key="assemblySheet.id"
            @click="viewAssemblySheet(assemblySheet.id)">
            <td @click.stop="">
              <v-checkbox 
                :value="selected.includes(assemblySheet.id)" 
                @input="toggleSelected(assemblySheet.id)"/>
            </td>
            <td>{{ assemblySheet.project.project_name }}</td>
            <td>{{ assemblySheet.assemblysheet_no }}</td>
            <td>{{ assemblySheet.condition }}</td>
            <td>{{ assemblySheet.desc }}</td>
            <td>
              <a 
                v-if="assemblySheet.attachment != null"
                @click.stop=""
                :href="assemblySheet.attachment" 
                alt="assembly sheet attachment"
                target="_blank">
                attachment
              </a>
            </td>
            <td>{{ assemblySheet.details.length }}</td>
            <td>
              <div class="buttons buttons-right">
                <button
                  @click.stop="launchConfirmDelete(assemblySheet.id)" 
                  class="button is-small">
                  <span class="icon">
                    <i class="fas fa-trash has-text-grey"></i>
                  </span>
                  <span>Delete</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </v-fade-transition>

    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>

  </div>
</template>

<script>
import VConfirmModal from '@/components/base/VConfirmModal'
import VPagination from '@/components/base/VPagination'
import VCheckbox from '@/components/base/VCheckbox'
import VProgress from '@/components/base/VProgress'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VConfirmModal, VPagination, VCheckbox, VProgress, VFadeTransition 
  },
  data() {
    return {
      headers: [
        { label: 'Project Name' },
        { label: 'Assembly Sheet No.' },
        { label: 'Condition' },
        { label: 'Description' },
        { label: 'Attachment' },
        { label: '# of Parts' }
      ],
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this assembly sheet?',
        type: 'danger'
      },
      deleteConfirmedCb: null
    }
  },
  computed: {
    ...mapState("assembly", [
      "assemblySheets", "loading", "pagination", "selected", "allSelected"
    ])
  },
  watch: {
    'pagination.page'(page) {
      this.getAssemblySheets({ page: page });
    }
  },
  methods: {
    ...mapActions("assembly", [
      "getAssemblySheets", "deleteAssemblySheet", "toggleAllSelected"
    ]),
    ...mapMutations("assembly", ["changePage", "toggleSelected"]),
    ...mapMutations("app", ["setNotification"]),
    viewAssemblySheet(id) {
      this.$router.push({ 
        name: 'AssemblyView', 
        params: { assemblySheetId: id } 
      })
    },
    launchConfirmDelete(id) {
      if (!id) {
        this.deleteConfirmedCb = () => {
          this.selected.forEach(id => {
            this.deleteAssemblySheet(id);
            this.confirmDelete.state = false;
          })
        }
        this.confirmDelete.message = `Are you sure you want to delete the ${this.selected.length} assembly sheets?`;
        this.confirmDelete.state = true;
      } else {
        this.deleteConfirmedCb = () => {
          this.deleteAssemblySheet(id);
          this.confirmDelete.state = false;
        }
        this.confirmDelete.message = 'Are you sure you want to delete this assembly sheet?';
        this.confirmDelete.state = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>